var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked 1",
    clipPath: "url(#clip0_233_1576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M72 36C72 55.882 55.882 72 36 72C16.118 72 0 55.882 0 36C0 16.118 16.118 0 36 0C55.882 0 72 16.118 72 36Z",
    fill: "#04C65D"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\xF4\x80\x86\x85",
    d: "M33.5309 48.5C32.6241 48.5 31.8684 48.1536 31.2638 47.4607L23.7167 38.6826C23.4534 38.3923 23.2681 38.1114 23.1609 37.8399C23.0536 37.5684 23 37.2875 23 36.9972C23 36.3324 23.2291 35.7846 23.6874 35.3539C24.1555 34.9139 24.7405 34.6938 25.4426 34.6938C26.2226 34.6938 26.8711 34.9981 27.3879 35.6067L33.4724 42.8399L45.422 24.7079C45.7243 24.2678 46.0363 23.9588 46.3581 23.7809C46.6896 23.5936 47.0943 23.5 47.572 23.5C48.2741 23.5 48.8543 23.7154 49.3126 24.1461C49.7709 24.5768 50 25.1199 50 25.7753C50 26.0187 49.9561 26.2715 49.8684 26.5337C49.7806 26.7959 49.6441 27.0674 49.4588 27.3483L35.8418 47.3624C35.3055 48.1208 34.5352 48.5 33.5309 48.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_1576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.a5fa285a2b3c1b4c831bd62862e58ceb.svg";
export { ForwardRef as ReactComponent };